import { style } from "@vanilla-extract/css";
import { vars } from "../../../styles/theme.css";

// TODO: refactor styles once we have a tooltip design
export const tooltipStyles = style({
  transform: "translate3d(0, 0, 0)",
  transition: "transform 200ms, opacity 200ms",
  outline: "none",
  borderRadius: vars.radii.xs,
  boxShadow: "0 8px 20px rgba(0 0 0 / 0.2)",
  background: vars.colors.inverseSurface,
  padding: vars.space.xs,
  maxWidth: "150px",
  color: vars.colors.inverseOnSurface,
  /* fixes FF gap */
  fontSize: vars.fontSizes.body.s,
  forcedColorAdjust: "none",

  selectors: {
    "&[data-entering], &[data-exiting]": {
      transform: "var(--origin)",
      opacity: 0,
    },
    "&[data-placement=top]": {
      marginBottom: vars.space.xs,
      vars: {
        "--origin": "translateY(4px)",
      },
    },
    "&[data-placement=bottom]": {
      marginTop: vars.space.xs,
      vars: {
        "--origin": "translateY(-4px)",
      },
    },
    "&[data-placement=right]": {
      marginLeft: vars.space.xs,
      vars: {
        "--origin": "translateX(-4px)",
      },
    },
    "&[data-placement=left]": {
      marginInlineEnd: vars.space.xs,
      vars: {
        "--origin": "translateX(4px)",
      },
    },
  },
});

export const arrow = style({
  display: "block",
  fill: vars.colors.inverseSurface,
  stroke: vars.colors.inverseSurface,
  strokeWidth: 1,
  selectors: {
    "[data-placement=bottom] &": {
      transform: "rotate(180deg)",
    },
    "[data-placement=right] &": {
      transform: "rotate(90deg)",
    },
    "[data-placement=left] &": {
      transform: "rotate(-90deg)",
    },
  },
});
